import styled from "styled-components";

export const Container = styled.div`
  background-color: #ececec;
  border-radius: 8px;
  width: 295px;
  min-width: max-content;
  height: 68vh;
  max-height: 68vh;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
  ::-webkit-scrollbar {
    width: 0px;
    background: transparent;
  }
  contain: layout style paint;
`;

export const Header = styled.div`
  z-index: 999;
  background-color: #ffffff;
  display: flex;
  width: 295px;
  min-width: max-content;
  height: 40px;
  border: 2px solid #d5d5d5;
  border-radius: 8px;
  align-items: center;
  justify-content: space-between;
  top: 0;
  padding: 12px 16px;
  position: sticky;
`;

export const BodySkeleton = styled.div`
  margin: 0 12px;
  margin-bottom: 12px;
`;

export const TextEtapa = styled.p`
  //styleName: SM/Medium;
  font-family: Inter;
  font-size: 13px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: -0.01em;
`;

export const SpaceY: any = styled.div`
  height: ${(props: any) => props.space}px !important;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 0;
  width: 100%;
`;
